import { FormModelPerson, Person } from 'src/types/person';

export const initialPerson: Person = {
  firstName: '',
  lastName: '',
  companyName: '',
  email: '',
  phone: '',
  mailingAddress: '',
};

const initialFormValues: FormModelPerson = {
  ...initialPerson,
  sameAsPropertyAddress: false,
};

export const getInitialFormModelValues = (): FormModelPerson => {
  return {
    ...initialFormValues,
  };
};

export const mapOwnersToFormModel = (
  owners: Person[],
  propertyAddress: string = ''
): FormModelPerson[] => {
  return owners.map((owner) => ({
    ...owner,
    sameAsPropertyAddress: Boolean(
      owner.mailingAddress &&
        owner.mailingAddress.toLowerCase() === propertyAddress.toLowerCase()
    ),
  }));
};

export const mapFormModelToPerson = ({
  sameAsPropertyAddress,
  ...rest
}: FormModelPerson): Person => ({
  ...rest,
});
